var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 574.69 12.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,12.3v-2.15l10.48-3.99L0,2.17V0l12.57,4.86v2.59L0,12.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.79,12.3v-2.15l10.48-3.99-10.48-3.99V0l12.57,4.86v2.59l-12.57,4.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.58,12.3v-2.15l10.48-3.99-10.48-3.99V0l12.57,4.86v2.59l-12.57,4.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.38,12.3v-2.15l10.48-3.99-10.48-3.99V0l12.57,4.86v2.59l-12.57,4.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.17,12.3v-2.15l10.48-3.99-10.48-3.99V0l12.57,4.86v2.59l-12.57,4.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.9,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.69,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.48,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.27,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m136.07,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150.86,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.65,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.44,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.24,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m210.03,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.82,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.61,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.41,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.2,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.99,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m298.78,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m313.58,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m328.37,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m343.16,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m357.95,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.75,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.54,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m402.33,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m417.12,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m431.92,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m446.71,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.5,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m476.29,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m491.09,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m505.88,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m520.67,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m535.46,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m550.26,6.9v-2.29h6.24v2.29h-6.24Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m562.11,12.3v-2.15l10.48-3.99-10.48-3.99V0l12.57,4.86v2.59l-12.57,4.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobile);
export default __webpack_public_path__ + "static/media/arrow-mobile.0580561f5897e09a680d343a74432cc9.svg";
export { ForwardRef as ReactComponent };